import { render, staticRenderFns } from "./GptChats.vue?vue&type=template&id=aefb6866&scoped=true&"
import script from "./GptChats.vue?vue&type=script&lang=ts&"
export * from "./GptChats.vue?vue&type=script&lang=ts&"
import style0 from "./GptChats.vue?vue&type=style&index=0&id=aefb6866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefb6866",
  null
  
)

/* custom blocks */
import block0 from "./GptChats.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports